import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { deleteVehicle } from '@api/vehicles';
import { toast } from '@ui/components';

export const useRemoveVehicleDialog = (onSuccess?: () => void) => {
  const { t } = useTranslation();

  const { mutate: removeVehicle, isPending } = useMutation({
    mutationFn: deleteVehicle,
    onSuccess: () => {
      onSuccess?.();
      toast.success(t('VEHICLES.REMOVE_DIALOG_SUCCESS'));
    },
    onError: () => {
      toast.error(t('VEHICLES.REMOVE_DIALOG_ERROR'));
    },
  });

  return {
    removeVehicle,
    isPending,
    t,
  };
};
